<template>
  <div>
    <ts-page-title
      :title="$t('attendanceDevice.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('attendanceDevice.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="addNew">{{
          $t('addNew')
        }}</Button>
        <div class="ts-justify-end ts-space-x-2">
          <Input
            search
            v-model="search"
            :placeholder="$t('attendanceDevice.search')"
            :style="width"
            @on-focus="() => (width = 'width: 500px')"
            @on-blur="() => (width = 'width: 300px')"
          />
        </div>
      </ts-panel-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
        <template slot-scope="{ row }" slot="deviceType">
          {{ row.att_device_type ? row.att_device_type.att_device_type : '' }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <Poptip
            confirm
            :title="$t('areYouSure')"
            @on-ok="onDelete(row)"
            :transfer="true"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
          >
            <a
              class="text-danger"
              v-tooltip="$t('delete')"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </Poptip>
        </template>
      </Table>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>

      <!-- form-action -->
      <a-modal
        v-model="showForm"
        draggable
        sticky
        scrollable
        :mask="false"
        :footer="null"
        :z-index="1022"
        :closable="true"
        :title="$t('attendanceDevice.pageTitle')"
      >
        <from-action
          ref="form_action"
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-panel>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'attendance-deviceIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('humanResource/attendanceDevice', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.humanResource.attendanceDevice.search
      },
      set(newValue) {
        this.$store.commit(
          'humanResource/attendanceDevice/SET_SEARCH',
          newValue
        )
        this.$store.commit('humanResource/attendanceDevice/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('attendanceDevice.deviceName'),
          key: 'device_name'
        },
        {
          title: this.$t('attendanceDevice.deviceIp'),
          key: 'device_ip'
        },
        {
          title: this.$t('attendanceDevice.port'),
          key: 'port'
        },
        {
          title: this.$t('attendanceDevice.deviceType'),
          slot: 'deviceType'
        },
        {
          title: this.$t('attendanceDevice.sdkVersion'),
          key: 'sdk_version'
        },
        {
          title: this.$t('attendanceDevice.remarks'),
          key: 'remarks'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          align: 'center',
          fixed: 'right',
          className: 'ts-space-x-2',
          width: 90
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('humanResource/attendanceDevice/fetch', {
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
    async onEdit(record) {
      this.showForm = true
      await this.$store.commit(
        'humanResource/attendanceDevice/SET_EDIT_DATA',
        record
      )
      await this.$refs.form_action.setEditData()
    },
    clearEdit() {
      this.showForm = false
      this.$refs.form_action.setEditData()
      this.$refs.form_action.clearInput()
      this.$store.commit('humanResource/attendanceDevice/SET_EDIT_DATA', {})
    },
    async addNew() {
      this.showForm = true
      await this.$store.commit(
        'humanResource/attendanceDevice/SET_EDIT_DATA',
        {}
      )
      await this.$refs.form_action.setEditData()
      this.$refs.form_action.clearInput()
    },
    async onDelete(record) {
      record._deleting = true
      this.$store
        .dispatch('humanResource/attendanceDevice/destroy', record.device_id)
        .then(response => {
          this.fetchData()
          record._deleting = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          record._deleting = false
        })
    },

    notice(not) {
      this.$Notice[not.type]({
        title: 'ATTENDANCE DEVICE',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('humanResource/attendanceDevice/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
